import React from 'react';

import './DisposableEmailNoticeModal.css';

interface DisposableEmailNoticeModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const DisposableEmailNoticeModal: React.FC<DisposableEmailNoticeModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="disposable-notice-overlay" onClick={onClose}>
      <div className="disposable-notice-modal" onClick={(e) => e.stopPropagation()}>
        <div className="disposable-notice-header">
          <div className="disposable-notice-title">
            <span className="disposable-notice-icon">⚠️</span>
            Temporary Email Detected
          </div>
          <button className="disposable-notice-close" onClick={onClose}>×</button>
        </div>

        <p className="disposable-notice-text">
          Your account was created with a temporary email address, so no free
          credits will be provided for this account. Sign up with a permanent
          email address to receive free signup credits.
        </p>

        <button className="disposable-notice-button" onClick={onClose}>
          Got it
        </button>
      </div>
    </div>
  );
};
